import { Component, Input, OnInit } from '@angular/core';
import { TopPerformingGroupsDataDto } from '@sociuu/interfaces';

@Component({
  selector: 'sociuu-top-performing-groups',
  templateUrl: './top-performing-groups.component.html',
  styleUrls: ['./top-performing-groups.component.scss']
})
export class TopPerformingGroupsComponent implements OnInit {

  @Input() topPerformingGroups: TopPerformingGroupsDataDto[];
  @Input() loadingText: string = "Working";

  constructor() { }

  ngOnInit(): void {
  }

}
